import { render, staticRenderFns } from "./product-title.component.vue?vue&type=template&id=718c5a90&scoped=true&"
import script from "./product-title.component.vue?vue&type=script&lang=js&"
export * from "./product-title.component.vue?vue&type=script&lang=js&"
import style0 from "./product-title.component.vue?vue&type=style&index=0&id=718c5a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c5a90",
  null
  
)

export default component.exports